import { posToDOMRect } from '@tiptap/core';
import type { Editor } from '@tiptap/react';

import type { RicosPluginToolbar } from './../../../ricos-plugins/pluginToolbar';

const getFirstNodeChildElement = (selectedDOM: Node | null) => {
  if (!selectedDOM || !(selectedDOM instanceof HTMLElement)) {
    return null;
  }
  const ricosNodeFirstChild =
    selectedDOM?.querySelector?.('[data-hook~=ricos-node]')?.firstChild ?? null;

  if (!ricosNodeFirstChild || !(ricosNodeFirstChild instanceof HTMLElement)) {
    return null;
  }

  return ricosNodeFirstChild;
};

export const getReferenceElement = (
  toolbar: RicosPluginToolbar | undefined,
  tiptapEditor: Editor
) => {
  if (!toolbar) {
    return null;
  }

  const resolveReferenceElement = toolbar.getReferenceElementResolver();

  if (resolveReferenceElement) {
    return resolveReferenceElement(tiptapEditor);
  }

  const selectedDOM = tiptapEditor.view.nodeDOM(tiptapEditor.state.selection.from);
  const firstNodeChild = getFirstNodeChildElement(selectedDOM);

  if (firstNodeChild) {
    return firstNodeChild;
  }

  return {
    getBoundingClientRect: () => {
      const { state, view } = tiptapEditor;
      const { from, to } = state.selection;
      return posToDOMRect(view, from, to);
    },
  };
};
